(() => {
  if (window.__FAJ_ARTICLE_INSIGHTS_V8__) return;
  window.__FAJ_ARTICLE_INSIGHTS_V8__ = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const stickyAncestorMap = new Map();
  let lastTrigger = null;

  function fallbackCopy(value) {
    const input = document.createElement('input');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    input.style.pointerEvents = 'none';

    document.body.appendChild(input);
    input.select();

    try {
      document.execCommand('copy');
    } finally {
      input.remove();
    }
  }

  async function copyUrl(button) {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(window.location.href);
      } else {
        fallbackCopy(window.location.href);
      }

      button.classList.add('is-copied');
      button.setAttribute('aria-label', 'Link copied');

      window.setTimeout(() => {
        button.classList.remove('is-copied');
        button.setAttribute('aria-label', 'Copy article link');
      }, 1600);
    } catch (error) {
      fallbackCopy(window.location.href);
    }
  }

  function restoreStickyAncestors(section) {
    const ancestors = stickyAncestorMap.get(section) || [];

    ancestors.forEach((ancestor) => {
      ancestor.classList.remove('faja-sticky-sidebar-overflow-fix');
    });

    stickyAncestorMap.delete(section);
  }

  function prepareStickyAncestors(section) {
    restoreStickyAncestors(section);

    if (
      !section ||
      section.dataset.fajaStickySidebar !== 'true' ||
      !desktopQuery.matches ||
      !section.querySelector('[data-faja-sidebar] .faja-sidebar__sticky')
    ) {
      return;
    }

    const fixedAncestors = [];
    let ancestor = section.parentElement;

    while (ancestor && ancestor !== document.body) {
      const styles = window.getComputedStyle(ancestor);
      const overflowValues = [styles.overflow, styles.overflowX, styles.overflowY];

      const clipsSticky = overflowValues.some((value) =>
        ['hidden', 'clip', 'auto', 'scroll'].includes(value)
      );

      const isActualVerticalScroller =
        ancestor.scrollHeight > ancestor.clientHeight + 2 &&
        ['auto', 'scroll'].includes(styles.overflowY);

      if (clipsSticky && !isActualVerticalScroller) {
        ancestor.classList.add('faja-sticky-sidebar-overflow-fix');
        fixedAncestors.push(ancestor);
      }

      ancestor = ancestor.parentElement;
    }

    if (fixedAncestors.length) {
      stickyAncestorMap.set(section, fixedAncestors);
    }
  }

  function prepareAllStickyAncestors(root = document) {
    if (root.matches?.('[data-faja]')) {
      prepareStickyAncestors(root);
    }

    root.querySelectorAll?.('[data-faja]').forEach(prepareStickyAncestors);
  }

  function restoreAllStickyAncestors(root = document) {
    if (root.matches?.('[data-faja]')) {
      restoreStickyAncestors(root);
    }

    root.querySelectorAll?.('[data-faja]').forEach(restoreStickyAncestors);
  }

  function getSection(element) {
    return element?.closest('[data-faja]') || null;
  }

  function getDrawer(section) {
    return section?.querySelector('[data-faja-sidebar]') || null;
  }

  function getBackdrop(section) {
    return section?.querySelector('.faja-sidebar-backdrop') || null;
  }

  function getTrigger(section) {
    return section?.querySelector('[data-faja-mobile-sidebar-open]') || null;
  }

  function setDrawerA11y(drawer, open) {
    if (!drawer) return;

    if (mobileQuery.matches) {
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    } else {
      drawer.removeAttribute('aria-hidden');
    }
  }

  function openDrawer(trigger) {
    if (!mobileQuery.matches) return;

    const section = getSection(trigger);
    const drawer = getDrawer(section);
    const backdrop = getBackdrop(section);

    if (!drawer || !backdrop) return;

    lastTrigger = trigger;

    drawer.classList.add('is-mobile-open');
    backdrop.classList.add('is-mobile-open');
    trigger.setAttribute('aria-expanded', 'true');
    setDrawerA11y(drawer, true);
    document.body.classList.add('faja-mobile-sidebar-open');

    window.requestAnimationFrame(() => {
      const focusTarget = drawer.querySelector('[data-faja-mobile-sidebar-close]');
      focusTarget?.focus({ preventScroll: true });
    });
  }

  function closeDrawer(section, restoreFocus = true) {
    const drawer = getDrawer(section);
    const backdrop = getBackdrop(section);
    const trigger = getTrigger(section);

    if (!drawer) return;

    drawer.classList.remove('is-mobile-open');
    backdrop?.classList.remove('is-mobile-open');
    trigger?.setAttribute('aria-expanded', 'false');
    setDrawerA11y(drawer, false);
    document.body.classList.remove('faja-mobile-sidebar-open');

    if (restoreFocus && lastTrigger?.isConnected) {
      lastTrigger.focus({ preventScroll: true });
    }

    lastTrigger = null;
  }

  function closeAllDrawers(restoreFocus = false) {
    document.querySelectorAll('[data-faja]').forEach((section) => {
      closeDrawer(section, restoreFocus);
    });
  }

  function focusableElements(drawer) {
    return Array.from(
      drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => {
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  document.addEventListener('click', (event) => {
    const copyButton = event.target.closest('[data-faja-copy-url]');
    if (copyButton) {
      event.preventDefault();
      copyUrl(copyButton);
      return;
    }

    const openButton = event.target.closest('[data-faja-mobile-sidebar-open]');
    if (openButton) {
      event.preventDefault();
      openDrawer(openButton);
      return;
    }

    const closeButton = event.target.closest('[data-faja-mobile-sidebar-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer(getSection(closeButton), true);
      return;
    }

    const contactButton = event.target.closest(
      '[data-faja-sidebar] [data-faj-contact-open]'
    );
    if (contactButton) {
      closeDrawer(getSection(contactButton), false);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!mobileQuery.matches) return;

    const openDrawerElement = document.querySelector(
      '[data-faja-sidebar].is-mobile-open'
    );

    if (!openDrawerElement) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer(getSection(openDrawerElement), true);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusables = focusableElements(openDrawerElement);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function syncResponsiveState() {
    document.querySelectorAll('[data-faja]').forEach((section) => {
      prepareStickyAncestors(section);

      const drawer = getDrawer(section);
      if (!drawer) return;

      if (mobileQuery.matches) {
        const isOpen = drawer.classList.contains('is-mobile-open');
        setDrawerA11y(drawer, isOpen);
      } else {
        drawer.classList.remove('is-mobile-open');
        getBackdrop(section)?.classList.remove('is-mobile-open');
        getTrigger(section)?.setAttribute('aria-expanded', 'false');
        drawer.removeAttribute('aria-hidden');
      }
    });

    if (!mobileQuery.matches) {
      document.body.classList.remove('faja-mobile-sidebar-open');
      lastTrigger = null;
    }
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncResponsiveState);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncResponsiveState);
  }

  if (typeof desktopQuery.addEventListener === 'function') {
    desktopQuery.addEventListener('change', syncResponsiveState);
  } else if (typeof desktopQuery.addListener === 'function') {
    desktopQuery.addListener(syncResponsiveState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncResponsiveState,
      { once: true }
    );
  } else {
    syncResponsiveState();
  }

  document.addEventListener('shopify:section:load', (event) => {
    prepareAllStickyAncestors(event.target);
    syncResponsiveState();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    restoreAllStickyAncestors(event.target);
    closeAllDrawers(false);
  });
})();
